<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errors.old_password }"
      )
        .form-elem__title Старый пароль
        .form-elem__body
          input.input.input_full(
            type="password"
            v-model="userCredentials.old_password"
            v-on:keyup="keymonitor"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errors.password }"
      )
        .form-elem__title Новый пароль
        .form-elem__body
          input.input.input_full(
            type="password"
            v-model="userCredentials.password"
            v-on:keyup="keymonitor"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errors.password2 }"
      )
        .form-elem__title Новый пароль еще раз
        .form-elem__body
          input.input.input_full(
            type="password"
            v-model="userCredentials.password2"
            v-on:keyup="keymonitor"
          )
    .form__elem.form__elem_button
      .form-elem
        .form-elem__body
          button.button.button_paint-main(
            @click="onChangePassword($event)"
          ) Изменить пароль
        .form-elem__error(v-show="errorMsg.length > 0") {{ errorMsg }}
</template>
<script>
import {mapActions} from "vuex";

export default {
  name: "PasswordChangeForm",
  data: () => ({
    userCredentials: {
      old_password: "",
      password: "",
      password2: ""
    },
    errors: {
      old_password: false,
      password: false,
      password2: false
    },
    errorMsg: ""
  }),
  methods: {
    ...mapActions(["changePassword"]),
    keymonitor() {
      this.errorMsg = "";
      this.errors = {
        old_password: false,
        password: false,
        password2: false
      };
    },
    onChangePassword(e) {
      e.preventDefault();
      const errors = [];
      if (this.userCredentials.old_password.length < 8) {
        errors.push("old_password");
      }
      if (this.userCredentials.password.length < 8) {
        errors.push("password");
      }
      if (this.userCredentials.password2.length < 8) {
        errors.push("password2");
      }
      if (this.userCredentials.password2 !== this.userCredentials.password) {
        errors.push("password2");
        errors.push("password");
      }
      if (errors.length > 0) {
        errors.map(error => {
          this.errors[error] = true;
          return error;
        });
        return;
      }
      this.changePassword({
        data: this.userCredentials
      }).then(res => {
        if (res.status === 200) {
          this.$root.$emit("onShowNotificationModal", {
            text: "Пароль успешно обновлен!"
          });
          this.userCredentials = {
            old_password: "",
            password: "",
            password2: ""
          };
        } else {
          if (res.data.old_password) {
            this.errors.old_password = true;
            this.errorMsg = "-Не правильный старый пароль! \n";
          }
          if (res.data.password) {
            this.errors.password = true;
            this.errors.password2 = true;
            this.errorMsg += "-Пароль слишком простой";
          }
        }
      });
    }
  }
};
</script>
